
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'redirectLink': {'textDecoration': `none`,},'linkText': {'fontFamily': `'Lato-Regular-Regular', sans-serif`,'color': `#000000`,},
        
      };
    };
  